export const ISCHART_STUDIO_GS = "gs://mehealthportal-studio"
export const ISCHART_INFORMATICS_GS = "gs://mehealthportal-informatics"
